/**
 * 会期単位のリアル展来場バッジ印刷処理
 */
export function initRealEventBadgePrint() {
    initPrintButton();
}
/**
 * 印刷ボタンの初期化
 */
function initPrintButton() {
    const printButton = document.getElementById("badge-print-button");
    if (printButton === null)
        return;
    printButton.addEventListener("click", function () {
        const printArea = document.getElementById("badge-area").innerHTML;
        if (printArea === null)
            return;
        const otherElements = document.querySelectorAll("body > *");
        otherElements.forEach((element) => {
            element.classList.add("print-off");
        });
        document.body.insertAdjacentHTML("beforeend", '<div id="print"></div>');
        document.getElementById("print").insertAdjacentHTML("beforeend", printArea);
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant'
            });
            // 印刷プレビューの表示
            window.print();
            // 印刷後に非表示化したものを戻す
            document.body.removeChild(document.getElementById("print"));
            const print_off_elements = document.querySelectorAll(".print-off");
            print_off_elements.forEach((element) => {
                element.classList.remove("print-off");
            });
        }, 200);
    });
}
